// extracted by mini-css-extract-plugin
export var popoverMainRow = "_218d0af0657d88fdda3a9f2d5148873d-css";